import { lang } from 'enablex/shared'
import React, { FC, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import PageContainer from '~/app/common/PageContainer'
import { AppState } from '~/app/rootReducer'
import CreateDepartmentModal from './CreateDepartmentModal'
import { fetchDepartments } from './reducer'
import DepartmentList from './DepartmentList'

type Props = ConnectedProps<typeof connector>

interface Department {
  id: number
  name: string
  email?: string
  status: 'active' | 'suspended'
  workspaceId: string
  createdAt: Date
  updatedAt: Date
}

const Departments: FC<Props> = props => {
  const [createModalOpen, setCreateModalOpen] = useState(false)

  useEffect(() => {
    props.fetchDepartments()
  }, [])

  const onDepartmentUpdated = () => {
    props.fetchDepartments()
  }

  const onDepartmentCreated = (createdDepartment: Department) => {
    setCreateModalOpen(false)
    props.fetchDepartments()
  }

  const openModal = (flag: boolean) => {
    setCreateModalOpen(flag)
  }

  return (
    <PageContainer
      title="Departments"
      helpText="Manage departments for your workspace"
      fullWidth={true}
    >
      <DepartmentList
        departments={props.departments || []}
        loading={props.loading}
        onDepartmentUpdated={onDepartmentUpdated}
        openModal={openModal}
      />

      <CreateDepartmentModal
        isOpen={createModalOpen}
        toggleOpen={() => setCreateModalOpen(!createModalOpen)}
        onDepartmentCreated={onDepartmentCreated}
      />
    </PageContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  loading: state.departments.loading,
  departments: state.departments.departments
})

const connector = connect(mapStateToProps, { fetchDepartments })

export default connector(Departments)
